export default __webpack_public_path__ + "static/media/Milan_Horizontal_Reverse_Vector.7562c119.svg";